import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DemoService } from './../../demo.service';
import { FileUploaderService } from './../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../services/global-functions.service';
import { MysqlService } from './../../services/mysql.service';

import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-client-user-profile-edit',
  templateUrl: './client-user-profile-edit.component.html',
  styleUrls: ['./client-user-profile-edit.component.css']
})
export class ClientUserProfileEditComponent implements OnInit {
  nav: any;
  user_id: number;

  constructor( 
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient: HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService
     ) {
      this.nav = document.querySelector('nav.navbar');
  
      this.user_id = +this.route.snapshot.paramMap.get('user_id');  
    
    }

  ngOnInit() {
  }

}
